import axiosInstance from "./axiosInstance";

// Get all events
export const getEvents = async () => {
  const response = await axiosInstance.get("/sheets/events");
  return response.data;
};

// // Get single event
// export const getEventById = async (id) => {
//   const response = await axiosInstance.get(`/sheets/events/${id}`);
//   return response.data;
// };

// // Create new event
// export const createEvent = async (eventData) => {
//   const response = await axiosInstance.post("/sheets/events", eventData);
//   return response.data;
// };
